// extracted by mini-css-extract-plugin
export default {"ErrorLogo":"Error_ErrorLogo__tUNlB","ErrorMessage":"Error_ErrorMessage__u30LF"};